var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "filter-overview" },
    [
      _vm._l(_vm.activeFilters, function (filter) {
        return _c("div", { key: filter.id }, [
          _vm._v("\n\t\t" + _vm._s(_vm.$tMetaDisplayName(filter))),
          filter.groupId
            ? _c("small", [_vm._v(" (" + _vm._s(filter.groupId) + ")")])
            : _vm._e(),
          _vm._v(": "),
          _c("i", [_vm._v(_vm._s(_vm.summaryMap[filter.id]))]),
        ])
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sub-corpus-size" },
        [
          _vm.error
            ? [
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(_vm.$t("filterOverview.error")) +
                    ": " +
                    _vm._s(_vm.error.message) +
                    "\n\t\t"
                ),
              ]
            : _vm.subCorpusStats
            ? [
                _vm._v(
                  "\n\t\t\t" + _vm._s(_vm.$t("filterOverview.subCorpus")) + ":"
                ),
                _c("br"),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticStyle: {
                      display: "inline-block",
                      "vertical-align": "top",
                    },
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(_vm.$t("filterOverview.totalDocuments")) +
                        ":"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(_vm.$t("filterOverview.totalTokens")) +
                        ":\n\t\t\t"
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticStyle: {
                      display: "inline-block",
                      "vertical-align": "top",
                      "text-align": "right",
                      "font-family": "monospace",
                    },
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t " +
                        _vm._s(_vm.matchingCount.documents.toLocaleString())
                    ),
                    _c("br"),
                    _vm._v(
                      "\n\t\t\t\t " +
                        _vm._s(_vm.matchingCount.tokens.toLocaleString()) +
                        "\n\t\t\t"
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticStyle: {
                      display: "inline-block",
                      "vertical-align": "top",
                      "text-align": "right",
                      "font-family": "monospace",
                    },
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t (" +
                        _vm._s(
                          _vm.frac2Percent(
                            _vm.matchingCount.documents / _vm.totalCorpusDocs
                          )
                        ) +
                        ")"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n\t\t\t\t (" +
                        _vm._s(
                          _vm.frac2Percent(
                            _vm.matchingCount.tokens / _vm.totalCorpusTokens
                          )
                        ) +
                        ")\n\t\t\t"
                    ),
                  ]
                ),
              ]
            : [
                _c("Spinner", { attrs: { xs: "", inline: "" } }),
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(_vm.$t("filterOverview.calculating")) +
                    "\n\t\t"
                ),
              ],
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }